import { Component, OnInit } from '@angular/core';
import { CommonService } from '@tech-services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from '@tech-services/session.service';
import { AppConfig } from '@tech-utils/app-config.service';

@Component({
  selector: 'tech-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  items: any;

  constructor(
    public commonService: CommonService,
    private sessionService: SessionService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.items = [];
    if(AppConfig.settings.myAccountModule)
      this.items.push({
        label: 'k002882',
        icon: 'user',
        iconType: 'fal',
        description: 'k003190',
        url: '/accountsettings',
      });
    if(AppConfig.settings.myClientRiskProfileModule)
      this.items.push({
        label: 'k000046',
        iconType: 'fal',
        icon: 'clipboard-list-check',
        description: 'k003191',
        url: '/riskprofile',
      });

    if(AppConfig.settings.myDocumentsModule)
      this.items.push({
        label: 'k000104', // Token: Documents',
        iconType: 'fal',
        icon: 'file-invoice',
        description: 'k004191',//Token: Your documents and contracts
        url: '/documents', 
      });
    if(AppConfig.settings.myPortfoliosModule)
      this.items.push({
        label: 'k004192', // Token: Mis carteras,
        iconType: 'fal',
        icon: 'suitcase',
        description: 'k004193',//Token: Toda la gestión de tus carteras
        url: '/portfolios',  //Aun no existe esta direccion
      });
    if(AppConfig.settings.myPendingTasksModule)
      this.items.push({
        label: 'k004194', // Token: Mis tareas pendientes
        iconType: 'fal',
        icon: 'hourglass-clock',
        description: 'k004195',//Token: Actividades por completar
        url: '/portfolios', //Aun no existe esta direccion
      });
    if (AppConfig.settings.financialDetailsModule)
      this.items.push({
        label: 'Your financial details',
        iconType: 'fal',
        icon: 'balance-scale',
        description: 'k004369',//Token: All your wealth in one place
        url: '/financialdetails',
      });
      if (AppConfig.settings.clientSupportModule)
        this.items.push({
          label: 'k003192',
          iconType: 'fal',
          icon: 'comments',
          description: 'k003193',
          url: '/chat',
        });
  }
}
